import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'update-immutable';
import TextareaAutosize from 'react-autosize-textarea';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Chat from 'modules/Chat';
import LoadingElement from 'components/Loading/LoadingElement';
import ClickOutside from 'components/ClickOutside';
import Button from 'components/Button';

// FIXME: This import sucks, create a wrapping component instead
const EmojiPicker = loadable(() => import(/* webpackChunkName: "emojis" */ './src/EmojiPicker'), {
  fallback: <LoadingElement />
});

export class _UserInput extends Component {
  state = { message: '', emojis: false };

  shouldComponentUpdate({ channel: nextChannel }, { message: nextMessage, emojis: nextEmojis }) {
    const { message, emojis } = this.state;
    return message !== nextMessage || emojis !== nextEmojis || nextChannel !== this.props.channel;
  }

  handleSelect = (emoji) => {
    this.props.focus();
    this.setState((prevState) => ({
      message: prevState.message + emoji.native,
      emojis: false
    }));
  };

  handleMessageChange = (e) => {
    this.setState({ message: e.target.value });
  };

  sendMessage = (e) => {
    e.preventDefault();
    const { message } = this.state;
    if (message && message.trim()) {
      this.props.send(this.state.message, this.props.channel);
      this.setState({ message: '' });
    }
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.sendMessage(e);
    }
  };

  toggleEmojis = () =>
    this.setState((prevState) =>
      update(prevState, {
        emojis: { $set: !prevState.emojis }
      })
    );

  render() {
    const { message, emojis } = this.state;

    return (
      <footer>
        <div className="inner">
          {emojis ? (
            <ClickOutside onClickOutside={this.toggleEmojis}>
              <EmojiPicker onSelect={this.handleSelect} />
            </ClickOutside>
          ) : null}
          <button
            className="chatFeatures emoji"
            type="button"
            title="Add emoji"
            onClick={this.toggleEmojis}
          >
            Emojis
          </button>
          <TextareaAutosize
            id="chatBox"
            value={message}
            onChange={this.handleMessageChange}
            onKeyPress={this.handleKeyPress}
            placeholder="Say something"
            rows={1}
            maxRows={4}
          />
          <Button
            id="postChat"
            name="sendMessage"
            className="button__grey"
            icon="/assets/images1/paper-plane.svg"
            onClick={this.sendMessage}
          />
        </div>
      </footer>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  send: (message, channel) => dispatch(Chat.actions.send({ value: message }, channel))
});

_UserInput.defaultProps = {
  channel: null
};

_UserInput.propTypes = {
  channel: PropTypes.string,
  send: PropTypes.func.isRequired,
  focus: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(_UserInput);
